import React, { Component, Fragment } from 'react';
import { Row, Col } from '@thd-olt-component/react-elements';
import Helmet from 'react-helmet-async';
import './ErrorPage.style.scss';

class ErrorPage extends Component {

  componentDidMount() {
  }

  render() {
    return (
      <Fragment>
        <Helmet title="Error Page" />
        <Row className="error-page" data-testid="errorContent">
          <Row className="grid isBound error-page">
            <Col className="error-page__container">
              <img src="https://assets.homedepot-static.com/images/v1/oops.svg" alt="" className="error-page__image" />
              <h1 className="error-page__title u__display-font--black">
                WE'RE FIXING IT.
              </h1>
              <div className="error-page__description">
                <p>Your search has found a page that's not responding.</p>
                <p>We'll have this patched up as soon as possible.</p>
              </div>
              <div className="error-page__buttons">
                <a className="bttn bttn--primary bttn--inline u__bottom--standard body__m-right-large" href="/">
                  <span className="bttn__content">Back to homepage</span>
                </a>
              </div>
            </Col>
          </Row>
        </Row>
      </Fragment>
    );
  }
}

export default ErrorPage;
